import $ from 'jquery';

$(() => {
  $('.collapse').on('show.bs.collapse', function(){
    var collapsed_element = $(this);

    $('.collapse').not(collapsed_element).collapse('hide');
  });
});